module.exports = __webpack_public_path__ + "img/maki.c13f832a.png";